import { render, staticRenderFns } from "./SubscriptionBaseData.vue?vue&type=template&id=a4c56750&"
import script from "./SubscriptionBaseData.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBaseData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubscriptionBaseData.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VTextField,
})
